import { FC, SVGProps } from 'react';

export const MobileIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 3.25C8.48122 3.25 7.25 4.48122 7.25 6V26C7.25 27.5188 8.48122 28.75 10 28.75H22C23.5188 28.75 24.75 27.5188 24.75 26V6C24.75 4.48122 23.5188 3.25 22 3.25H10ZM8.75 6C8.75 5.30964 9.30964 4.75 10 4.75H11.078C11.1187 4.75 11.1552 4.77483 11.1717 4.81205C11.4831 5.51197 12.1845 6 13 6H19C19.8155 6 20.5169 5.51197 20.8283 4.81205C20.8448 4.77483 20.8813 4.75 20.922 4.75H22C22.6904 4.75 23.25 5.30964 23.25 6V26C23.25 26.6904 22.6904 27.25 22 27.25H10C9.30964 27.25 8.75 26.6904 8.75 26V6Z"
			fill="currentColor"
		/>
	</svg>
);
